// extracted by mini-css-extract-plugin
export var inlineLink = "_4p-0";
export var inlineLinkButton = "_4p-1";